import React, { Component, PropTypes } from 'react';
import Dropzone from 'react-dropzone'
import _ from 'lodash';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import MovieIcon from 'material-ui/svg-icons/av/movie';
import { Grid, Row, Col } from 'react-flexbox-grid';

class VideoUpload extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className="video-upload">
        <Row center="xs">
          <Dropzone onDrop={this.props.onDrop} className="dropzone"
                    activeClassName="dropzone-active"
                    rejectClassName="dropzone-reject"
                    multiple={true}
                    accept="video/*">
            <label>拖放影片到此或按此</label>
          </Dropzone>
        </Row>
        {
          _.map(this.props.videosMeta, (videoMeta, index) =>
            <Row className="video-row" key={index}>
              <Col xs={4} className="video-info-container">
                <MovieIcon className="video-icon" />
                <div className="video-info">
                  <div className="video-name">{videoMeta.fileName}</div>
                  <div className="video-size">{videoMeta.fileSize}</div>
                </div>
              </Col>
              <Col xs={6}>
                <TextField
                  name="title"
                  hintText="名稱"
                  fullWidth={true}
                  value={videoMeta.title}
                  onChange={this.props.onVideosMetaChange.bind(this, 'title', index)}
                  type="text"
                  disabled={this.props.isUploading} />
              </Col>
              <Col xs={2}>
                <RaisedButton
                  label="刪除"
                  secondary={true}
                  icon={<i className="material-icons md-light">delete</i>}
                  onClick={this.props.onVideoRemove.bind(this, index)}
                  disabled={this.props.isUploading} />
              </Col>
            </Row>
          )
        }
      </div>
    )
  }
}

VideoUpload.propTypes = {
  isUploading: PropTypes.bool,
  onDrop: PropTypes.func,
  onVideoUpload: PropTypes.func,
  onVideoRemove: PropTypes.func,
  onVideosMetaChange: PropTypes.func,
  videosMeta: PropTypes.array,
};

VideoUpload.defaultProps = {
  isUploading: false,
  onDrop: () => {
  },
  onVideoUpload: () => {
  },
  onVideoRemove: () => {
  },
  onVideosMetaChange: () => {
  },
  videosMeta: [],
};

export default VideoUpload;


// WEBPACK FOOTER //
// client/adminPanel/panel/displays/VideoUpload.js